// src/firebase.js

import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signOut, updatePassword, sendEmailVerification, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";



// Initialize Firebase
const firebaseConfig = {
    apiKey: "AIzaSyB58ElJ4LZzP-iFAjkAMcESHucxJnDSEuE",
    authDomain: "sp-community-jobs.firebaseapp.com",
    projectId: "sp-community-jobs",
    storageBucket: "sp-community-jobs.firebasestorage.app",
    messagingSenderId: "467941492837",
    appId: "1:467941492837:web:732e97f8a8ce633a0b9e8c",
    measurementId: "G-850TNRYKPS"
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app); // Initialize auth with the app instance
const dbFirestore = getFirestore(app); // Initialize dbFirestore with the app instance
const storage = getStorage(app);


export { auth, dbFirestore, storage, onAuthStateChanged, signOut, updatePassword, sendEmailVerification, RecaptchaVerifier, signInWithPhoneNumber }; // Export auth and dbFirestore directly
export default app;